// Date formatting utilities — Romanian dd/mm/yyyy format throughout the app.
// Centralized so we can change format in ONE place if needed.

const PAD = (n) => String(n).padStart(2, "0");

/**
 * Format a date as zz/ll/an (dd/MM/yyyy).
 * Accepts Date, ISO string, or epoch. Returns "—" for invalid/empty.
 */
export function formatDate(d) {
  if (!d) return "—";
  const dt = d instanceof Date ? d : new Date(d);
  if (isNaN(dt.getTime())) return "—";
  return `${PAD(dt.getDate())}/${PAD(dt.getMonth() + 1)}/${dt.getFullYear()}`;
}

/**
 * Format a datetime as zz/ll/an HH:mm.
 */
export function formatDateTime(d) {
  if (!d) return "—";
  const dt = d instanceof Date ? d : new Date(d);
  if (isNaN(dt.getTime())) return "—";
  return `${PAD(dt.getDate())}/${PAD(dt.getMonth() + 1)}/${dt.getFullYear()} ${PAD(dt.getHours())}:${PAD(dt.getMinutes())}`;
}

/**
 * Format time only as HH:mm.
 */
export function formatTime(d) {
  if (!d) return "—";
  const dt = d instanceof Date ? d : new Date(d);
  if (isNaN(dt.getTime())) return "—";
  return `${PAD(dt.getHours())}:${PAD(dt.getMinutes())}`;
}

/**
 * Short date for compact rows: zz/ll/aa (dd/MM/yy).
 */
export function formatDateShort(d) {
  if (!d) return "—";
  const dt = d instanceof Date ? d : new Date(d);
  if (isNaN(dt.getTime())) return "—";
  return `${PAD(dt.getDate())}/${PAD(dt.getMonth() + 1)}/${String(dt.getFullYear()).slice(-2)}`;
}
